import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import FetchHook from "../../Api/FetchHooks";
import AlertComponent from "../../Components/AlertComponent";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../Components/PageLoader";
import TableComponent from "../../Components/TableComponent";
import Page from "../../Components/Page";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import { formatCurrencyV2, formatDate, getKycChip } from "../../utils/helpers";
import UseServerTable from "../../Hooks/UseServerTable";
import { AllInbox } from "@mui/icons-material";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { useSelector } from "react-redux";

const LoanRequests = ({ user, showHeader }) => {
  const navigate = useNavigate();

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [status, setStatus] = useState("closed");
  const [loanRequest, setLoanRequest] = useState([]);

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const apiUrl = useMemo(() => {
    const base = "/loan_request";

    //If no status, return base (per your original logic fallback)
    if (!status) return base;

    //Build parameters array
    const params = [];

    //Add Status: Backend requires single quotes wrapping the value e.g., status='closed'
    params.push(`status='${status}'`);

    //Add Entity ID: Only if user is customer AND we have a status (Constraint: entity_id not alone)
    if (user?.role === "customer" && user?.id) {
      params.push(`entity_id=${user.id}`);
    }

    //Join with '&' and return
    return `${base}?${params.join("&")}`;
  }, [status, user?.role, user?.id]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: apiUrl,
    onSuccess: (data) => {
      setLoanRequest(data.Loan);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  // const [loading, response, request] = FetchHook();

  // const fetchLoanReqs = useCallback(async () => {
  //   if (status != null && status != "") {
  //     await request({
  //       url: `/loan_request?status='${status}'`,
  //     });
  //   } else {
  //     await request({
  //       url: `/loan_request`,
  //     });
  //   }
  // }, [status]);

  // useEffect(() => {
  //   fetchLoanReqs();
  // }, [fetchLoanReqs]);

  // useEffect(() => {
  //   if (response?.data?.Loan) setLoanRequest(response.data.Loan);
  // }, [response]);

  const columns = [
    {
      field: "id",
      headerName: "#",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "loan_name",
      headerName: "Loan Name",
      minWidth: 140,
      flex: 1,
    },
    // {
    //   field: "inventory_id",
    //   headerName: "Inventory id",
    //   width: 160,
    // },
    // {
    //   field: "product_id",
    //   headerName: "Product id",
    //   width: 150,
    // },
    // {
    //   field: "supplier_id",
    //   headerName: "Supplier id",
    //   width: 150,
    // },
    // {
    //   field: "entity_id",
    //   headerName: "Entity id",
    //   width: 150,
    // },
    // {
    //   field: "amount_paid",
    //   headerName: "Amount paid",
    //   width: 120,
    // },
    {
      field: "loan_principal",
      headerName: "Amount applied",
      valueFormatter: (param) => formatCurrencyV2(param?.value),
      minWidth: 140,
      flex: 1,
    },
    // {
    //   field: "principal_balance",
    //   headerName: "Principle balance",
    //   width: 130,
    // },
    // {
    //   field: "loan_interest",
    //   headerName: "Loan interest",
    //   width: 130,
    // },
    // {
    //   field: "loan_interest_bal",
    //   headerName: "Loan interest bal",
    //   width: 130,
    // },
    // {
    //   field: "rollover_interest",
    //   headerName: "Rollover interest",
    //   width: 130,
    // },
    // {
    //   field: "rollover_interest_bal",
    //   headerName: "Rollover interest bal",
    //   width: 150,
    // },
    // {
    //   field: "debt_collection",
    //   headerName: "Debt collection",
    //   width: 130,
    // },
    // {
    //   field: "debt_collection_bal",
    //   headerName: "Debt collection bal",
    //   width: 130,
    // },
    // {
    //   field: "application_fee_amount",
    //   headerName: "Application fee amount",
    //   width: 150,
    // },
    // {
    //   field: "application_fee_bal",
    //   headerName: "Application fee bal",
    //   width: 150,
    // },
    // {
    //   field: "insurance_amount",
    //   headerName: "Insuarance amount",
    //   width: 150,
    // },
    // {
    //   field: "insurance_bal",
    //   headerName: "Insuarance amount bal",
    //   width: 150,
    // },
    // {
    //   field: "other_charges",
    //   headerName: "Other charges",
    //   width: 130,
    // },
    {
      field: "guarantor_saving",
      headerName: "Guarantorship amount",
      minWidth: 140,
      flex: 1,
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    {
      field: "guarantorship_balance",
      headerName: "Guarantorship balance",
      minWidth: 140,
      flex: 1,
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    // {
    //   field: "other_charges_bal",
    //   headerName: "Other charges",
    //   width: 130,
    // },
    // {
    //   field: "start_date",
    //   headerName: "Start date",
    //   width: 170,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "end_date",
    //   headerName: "End date",
    //   width: 170,
    //   valueFormatter: (params) => {
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A");
    //   },
    // },
    // {
    //   field: "last_contractual_instal_date",
    //   headerName: "last_contractual_instal_date",
    //   width: 170,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "next_actual_instal_date",
    //   headerName: "next_actual_instal_date",
    //   width: 170,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "next_contractual_instal_date",
    //   headerName: "next_contractual_instal_date",
    //   width: 170,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "net_actual_instal_date",
    //   headerName: "net_actual_instal_date",
    //   width: 170,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },

    // {
    //   field: "loan_approval_date",
    //   headerName: "Loan approval date",
    //   width: 170,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "loan_start_date",
    //   headerName: "Loan start date",
    //   width: 170,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "loan_end_date",
    //   headerName: "Loan end date",
    //   width: 170,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "description",
    //   headerName: "Description",
    //   width: 400,
    // },
    // {
    //   field: "status",
    //   headerName: "Status",
    // },
    {
      field: "active_status",
      headerName: "Status",
      minWidth: 140,
      flex: 1,
      renderCell: (params) => getKycChip(params?.value),
    },
    // {
    //   field: "loan_approval",
    //   headerName: "Loan approval",
    //   width: 120,
    // },
    {
      field: "loan_request_date",
      headerName: "Loan request date",
      minWidth: 140,
      flex: 1,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (row) => (
        <Box>
          <Button
            size="small"
            variant="outlined"
            style={{ marginLeft: 16, fontWeight: "bold" }}
            onClick={() => {
              navigate("/dashboard/loan-requests/profile", { state: row.row });
            }}
          >
            More
          </Button>
        </Box>
      ),
      minWidth: 140,
      flex: 1,
    },
  ];

  return (
    <Page title={"Loan Requests"} showHeader={showHeader}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">User Loan Requests</Typography>
              )}
            </>
          }
          action={
            <FormControl sx={{ width: "200px" }}>
              <InputLabel id="status" size="small">
                Status
              </InputLabel>

              <Select
                labelId="status"
                id="status"
                value={status}
                label="status"
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
                size="small"
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
                <MenuItem value="domant">Dormant</MenuItem>
                <MenuItem value="suspended">Suspended</MenuItem>
                <MenuItem value="closed">Closed</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="cancelled">Cancelled</MenuItem>
                <MenuItem value="incomplete">Incomplete</MenuItem>
                <MenuItem value="complete">Complete</MenuItem>
              </Select>
            </FormControl>
          }
        />
        <CardContent>
          {loanRequest && loanRequest.length > 0 ? (
            <>
              <TableComponent
                data={loanRequest}
                // columns={loggedInUser.role === "admin" ? columns : custCols}
                columns={columns}
                sortModel={[
                  {
                    field: "loan_request_date",
                    sort: "desc",
                  },
                ]}
                {...gridProps}
              />
            </>
          ) : gridProps.loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <ErrorDisplay
              message="No recent loanRequest"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default LoanRequests;
